import { ChildContactInfoSubmitter } from '../../lib/child-contact-info/child-contact-info-submit.service'
import { DocsChildContactInfoSubmitter } from './docs-child-contact-info-submitter.service'

export const PROVIDERS = [
  {
    provide: ChildContactInfoSubmitter,
    useClass: DocsChildContactInfoSubmitter,
  }
]
